import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
 
import { PcTabsPage } from '../pages/pc-tabs/pc-tabs';
import { PartesService } from '../services/partes.services';

import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule, /*AngularFireDatabase*/ } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AuthProvider } from '../providers/auth/auth';
import { HideKeyboardModule } from 'hide-keyboard';

import { Geolocation } from '@ionic-native/geolocation';
import { FichadaDetallePage} from '../pages/fichada-detalle/fichada-detalle';

export const firebaseConfig = {
  apiKey: "AIzaSyBPoUyYz34e4d2bZVKOS_pin4T921cRLUw",
  authDomain: "pccamp-a6cca.firebaseapp.com",
  databaseURL: "https://pccamp-a6cca.firebaseio.com",
  storageBucket: "pccamp-a6cca.appspot.com",
  messagingSenderId: '621926117959'
};

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    PcTabsPage,
    FichadaDetallePage,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp, {tabsHideOnSubPages: true,}),
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    HideKeyboardModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    PcTabsPage,
    FichadaDetallePage,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    PartesService,
    Geolocation,
    AuthProvider,
    
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts